import { TableHeadDataProps } from "../../components/Table/TableHead";

export const patientTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: "", value: "" },
  { id: 1, title: "Cycle", value: "billingCycleNumber" },
  { id: 2, title: "Alerts" },
  { id: 3, title: "Patient Name", value: "name" },
  { id: 4, title: "Actions" },
  // { id: 5, title: "Date of Birth", value: "dob" },
  // { id: 3, title: "Gender", value: "gender" },
  // { id: 4, title: "Contact Info", value: "email" },
  { id: 5, title: "Associated Clinic", value: "associatedClinic.name" },
  { id: 6, title: "Account Owner", value: "clinician" },
  { id: 7, title: "Message(x/n)", value: "transmission" },
  { id: 8, title: "Time", value: "timeSpent" },
  { id: 9, title: "Call Scheduled", value: "phoneCallReminderDate" },
  { id: 10, title: "Monthly Intake", value: "isPrequalified" },
  // { id: 11, title: "Call Status", value: "callStatus" },
  { id: 12, title: "Date Enrolled", value: "enrollDate" },
  // { id: 9, title: 'Days Left', value: 'leftDays' },
  // { id: 9, title: 'Days Left', value: 'leftDays' },
  // { id: 10, title: 'Status', },
  { id: 13, title: "Status" },
];
